export default __webpack_public_path__ + "static/review-icon-c28d64634e85cc2bcdef538eb6224045.png";